import {createSelector} from "@reduxjs/toolkit";

const getGroupsState = (state) => state.groupsState;

export const getGroupsSelector = createSelector(
   [getGroupsState],
    (groups) => groups,
);

export default getGroupsSelector;
